import type { ElementSize } from '@/composables/vueuse/use-element-size.ts'

export function getBoxSize(
    size: ReadonlyArray<ResizeObserverSize>
): ElementSize {
    return size.reduce(
        (acc, size) => {
            return {
                width: acc.width + size.inlineSize,
                height: acc.height + size.blockSize,
            }
        },
        { width: 0, height: 0 }
    )
}
